import React from 'react';

export const RefreshTableContext = React.createContext({
  refreshTable: false,
  checkRunRefresh: false,
  setRefreshTable: (value: boolean) => {}
});